module.exports = __webpack_public_path__ + "static/media/contemplar_te_8.e88bd623.jpg";